<template>
  <div class="home">
    <el-container>
      <!-- 左侧菜单 -->
      <el-aside
        :width="isMenuCollapsed ? '64px' : '200px'"
        height="100vh"
        style="
          height: 100vh;
          border-right: 1px solid #ebeef5;
          background-color: #fff;
          transition: width 0.3s ease-in-out;
          overflow: hidden;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
          display: flex;
          flex-direction: column;
          will-change: width;
          transform: translateZ(0);
        "
      >
        <!-- 左侧logo -->
        <div class="logo-container" :style="logoContainerStyle">
          <img
            class="logo"
            src="https://plc.shanhe.link/assets/logo/shanhe-logo/shanhe-logo.png"
            alt="logo"
          />
          <transition name="fade-horizontal">
            <div v-if="!isMenuCollapsed" class="logo-text">山禾云招</div>
          </transition>
        </div>
        <!-- 搜索框 -->
        <transition name="fade">
          <div class="search-box" v-if="!isMenuCollapsed">
            <div class="search-text">搜索菜单</div>
            <el-input
              placeholder="输入关键词搜索菜单"
              prefix-icon="el-icon-search"
              v-model="searchKeyword"
              size="small"
              clearable
              @input="handleSearch"
              @clear="clearSearch"
            ></el-input>
            <div
              v-if="searchKeyword && filteredMenuItems.length === 0"
              class="no-results"
            >
              未找到匹配的菜单项
            </div>
          </div>
        </transition>

        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          :collapse="isMenuCollapsed"
          :collapse-transition="true"
          background-color="#fff"
          text-color="#333"
          active-text-color="#ffffff"
          :style="{
            transition: 'width 0.3s ease-in-out, transform 0.3s ease-in-out',
            'backface-visibility': 'hidden',
          }"
          :default-openeds="getDefaultOpeneds"
          @select="handleMenuSelect"
        >
          <!-- 遍历导航项 -->
          <template v-for="(item, index) in filteredMenuItems">
            <!-- 有子菜单的导航项使用 el-submenu -->
            <el-submenu
              v-if="item.children && item.children.length > 0"
              :key="index"
              :index="item.path"
            >
              <template slot="title">
                <img
                  :src="
                    isSubMenuActive(item)
                      ? item.selectedIconPath
                      : item.iconPath
                  "
                  class="menu-icon"
                  alt="icon"
                />
                <span>{{ item.title }}</span>
              </template>
              <!-- 子菜单项 -->
              <el-menu-item
                v-for="(subItem, subIndex) in item.children"
                :key="subIndex"
                :index="subItem.path"
                @click="handleMenuClick(subItem)"
              >
                <img
                  :src="
                    activeMenu === subItem.path
                      ? subItem.selectedIconPath
                      : subItem.iconPath
                  "
                  class="menu-icon"
                  alt="icon"
                />
                <span>{{ subItem.title }}</span>
              </el-menu-item>
            </el-submenu>

            <!-- 没有子菜单的导航项使用 el-menu-item -->
            <el-menu-item
              v-else
              :key="index"
              :index="item.path"
              @click="handleMenuClick(item)"
            >
              <img
                :src="
                  activeMenu === item.path
                    ? item.selectedIconPath
                    : item.iconPath
                "
                class="menu-icon"
                alt="icon"
              />
              <span>{{ item.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <!-- 折叠按钮 -->
      <div
        class="collapse-menu-btn"
        @click="toggleMenu"
        :class="{ collapsed: isMenuCollapsed }"
      >
        <i :class="isMenuCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </div>

      <el-container class="main-container" style="position: relative">
        <el-header
          class="top-header"
          style="background-color: #fff; height: 9%"
        >
          <!-- 导航栏标题 - 点击的导航名称 -->
          <div class="nav-title">
            <span>{{ navTitle }}</span>
          </div>
          <!-- 顶部导航 -->
          <div class="user-flex">
            <div
              class="user-action-item user-vip"
              @click="$router.push('/member/shanhe')"
            >
              <img src="https://plc.shanhe.link/assets/VIP.png" alt="会员" />
              <span>会员中心</span>
            </div>
            <div
              class="user-action-item user-message"
              @mouseenter="showMessageDropdown = true"
              @mouseleave="handleMessageMouseLeave"
              ref="messageRef"
            >
              <img
                src="https://plc.shanhe.link/assets/message_v.png"
                alt="消息"
              />
              <!-- 消息下拉框 -->
              <transition name="message-fade">
                <div
                  v-show="showMessageDropdown"
                  class="message-dropdown"
                  @mouseenter="isMouseInDropdown = true"
                  @mouseleave="isMouseInDropdown = false"
                >
                  <div v-if="messages.length > 0" class="message-list">
                    <div
                      v-for="(msg, idx) in messages"
                      :key="idx"
                      class="message-item"
                    >
                      <div class="message-title">{{ msg.title }}</div>
                      <div class="message-content">{{ msg.content }}</div>
                      <div class="message-time">{{ msg.time }}</div>
                    </div>
                  </div>
                  <div v-else class="message-empty">
                    <i class="el-icon-chat-dot-square empty-icon"></i>
                    <p>暂无消息</p>
                  </div>
                </div>
              </transition>
            </div>
            <div class="user-name">
              <topUser :isHome="false" />
            </div>
          </div>
        </el-header>
        <el-main
          class="main-content"
          style="background-color: #fafafa; padding: 5px"
        >
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import topUser from "@/components/TopUser";
export default {
  components: {
    topUser,
  },
  data() {
    return {
      isMenuCollapsed: false, // 控制菜单展开/收起
      showMessageDropdown: false, // 控制消息下拉框显示/隐藏
      isMouseInDropdown: false, // 鼠标是否在下拉框内
      searchKeyword: "", // 搜索关键字
      activeMenu: "/regional-analysis", // 当前激活的菜单项
      /**
       * 消息
       */
      messages: [],
      /**
       * 导航栏标题
       */
      navTitle: "",
      /**
       * 导航栏信息
       * title: 导航栏标题
       * path: 导航栏路径
       * externalLink: 是否为外部链接
       * children: 子导航栏信息，如果children不为空，则为二级导航栏，否则为一级导航栏
       * iconPath: 导航栏图标路径
       * selectedIconPath: 导航栏图标选中路径
       */
      navigationBarInfo: [
        {
          title: "区域分析",
          path: "/",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/qyfx.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/qyfx.png",
          children: [],
        },
        {
          title: "产业招商",
          path: "/industrialDistribution",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/qyzs.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/hui/qyzs.png",
          children: [
            {
              title: "产业招商",
              path: "/industrialDistribution",
              externalLink: false,
              iconPath: "https://plc.shanhe.link/assets/nav/hui/qyza-child.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/qyzs.png",
            },
            {
              title: "迁出企业",
              path: "/emigration",
              externalLink: false,
              iconPath: "https://plc.shanhe.link/assets/nav/hui/migration.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/migration.png",
            },
          ],
        },
        {
          title: "产业链拆解",
          path: "/industrialChain",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/cylcj.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/cylcj.png",
          children: [],
        },
        {
          title: "产业大屏  ",
          path: "/IndustrialMap",
          externalLink: true,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/cydp.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/cydp.png",
          children: [],
        },
        {
          title: "产业地图",
          path: "/industrialScreenMap",
          externalLink: true,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/cydt.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/cydt.png",
          children: [],
        },
        {
          title: "企业投资",
          path: "/enterpriseInvestment",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/qytz.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/hui/qytz.png",
          children: [
            {
              title: "AI模型-投资",
              path: "/enterpriseInvestment",
              externalLink: false,
              iconPath:
                "https://plc.shanhe.link/assets/nav/hui/ai_mode_child.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/ai_mode_child.png",
            },
            {
              title: "大数据-投资",
              path: "/bigData",
              externalLink: false,
              iconPath: "https://plc.shanhe.link/assets/nav/hui/dsj_child.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/dsj_child.png",
            },
          ],
        },
        {
          title: "自有数据",
          path: "/ownData",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/zysj.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/zysj.png",
          children: [],
        },

        {
          title: "企业手机号",
          path: "/enterprisePhone",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/qysjh.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/qysjh.png",
          children: [],
        },
        {
          title: "园区文件",
          path: "/parkFile",
          externalLink: false,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/yqwj.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/yqwj.png",
          children: [
            {
              title: "园区文件",
              path: "/parkFile",
              externalLink: false,
              iconPath: "https://plc.shanhe.link/assets/nav/hui/yqwj_child.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/yqwj_child.png",
            },
            {
              title: "文件上传",
              path: "/fileUpload",
              iconPath: "https://plc.shanhe.link/assets/nav/hui/scwj_child.png",
              selectedIconPath:
                "https://plc.shanhe.link/assets/nav/bai/scwj_child.png",
              externalLink: false,
            },
          ],
        },
        {
          title: "山禾大模型",
          path: "/T1",
          externalLink: true,
          iconPath: "https://plc.shanhe.link/assets/nav/hui/T1.png",
          selectedIconPath: "https://plc.shanhe.link/assets/nav/bai/T1.png",
          children: [],
        },
      ],
    };
  },

  computed: {
    // logo容器样式
    logoContainerStyle() {
      return {
        justifyContent: this.isMenuCollapsed ? "center" : "flex-start",
        paddingLeft: this.isMenuCollapsed ? "0" : "15px",
      };
    },
    // 过滤后的菜单项
    filteredMenuItems() {
      if (!this.searchKeyword.trim()) {
        return this.navigationBarInfo;
      }

      const keyword = this.searchKeyword.toLowerCase();

      // 搜索主菜单项和子菜单项
      return this.navigationBarInfo.filter((item) => {
        // 检查主菜单项标题是否匹配
        const titleMatch = item.title.toLowerCase().includes(keyword);

        // 筛选匹配的子菜单项
        let filteredChildren = [];
        if (item.children && item.children.length) {
          filteredChildren = item.children.filter((child) =>
            child.title.toLowerCase().includes(keyword)
          );
        }

        // 如果主菜单匹配或有匹配的子菜单，则保留这个主菜单项
        const hasMatchingChildren = filteredChildren.length > 0;

        // 如果搜索关键字存在，且有匹配的子菜单，则替换原有子菜单
        if (this.searchKeyword.trim() && hasMatchingChildren) {
          // 创建一个新对象，避免修改原对象
          return {
            ...item,
            children: filteredChildren,
            // 添加一个标记，表示这个菜单项应该被展开
            _shouldExpand: true,
          };
        }

        return titleMatch || hasMatchingChildren;
      });
    },

    // 获取默认展开的菜单项
    getDefaultOpeneds() {
      if (!this.searchKeyword.trim()) {
        return [];
      }

      // 当有搜索关键字时，返回所有带有 _shouldExpand 标记的菜单项路径
      return this.filteredMenuItems
        .filter((item) => item._shouldExpand)
        .map((item) => item.path);
    },
  },

  mounted() {
    // 添加键盘事件监听
    window.addEventListener("keydown", this.handleKeyDown);
    // 设置当前激活的菜单
    this.setActiveMenu();
    // 检查父菜单激活状态
    this.checkParentMenus();
  },

  beforeDestroy() {
    // 移除键盘事件监听
    window.removeEventListener("keydown", this.handleKeyDown);
  },

  // 监听路由变化
  watch: {
    $route: {
      handler(to) {
        this.navTitle = to?.meta?.title || "数智产发";
        this.activeMenu = to.path;
        this.checkParentMenus();
      },
      immediate: true,
    },
  },

  methods: {
    // 检查父菜单的激活状态 - 简化版
    checkParentMenus() {
      // 仅记录日志，不执行实际操作，减少性能开销
    },

    // 设置当前激活的菜单
    setActiveMenu() {
      const path = this.$route.path;
      if (path) {
        this.activeMenu = path;
      } else {
        this.activeMenu = "/regional-analysis";
      }
    },

    // 切换菜单展开/收起
    toggleMenu() {
      // 直接切换状态，不需要额外的操作
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },

    // 处理消息框鼠标离开事件
    handleMessageMouseLeave() {
      // 只有当鼠标不在下拉框内时，才隐藏下拉框
      setTimeout(() => {
        if (!this.isMouseInDropdown) {
          this.showMessageDropdown = false;
        }
      }, 100);
    },

    // 处理键盘事件
    handleKeyDown(event) {
      // 检查是否按下 Alt + N
      if (event.altKey && event.key.toLowerCase() === "n") {
        event.preventDefault(); // 阻止默认行为
        this.toggleMenu();
      }
    },

    // 处理菜单点击事件
    handleMenuClick(item) {
      if (item.externalLink) {
        // 处理外部链接
        window.open("/#" + item.path, "_blank");
      } else if (item.children && item.children.length > 0) {
        // 有子菜单的项目跳转到第一个子菜单
        if (item.children[0] && !this.activeMenu.startsWith(item.path)) {
          this.activeMenu = item.children[0].path;
          this.$router.push(item.children[0].path);
        }
      } else {
        // 内部路由跳转
        if (this.$route.path !== item.path) {
          // 更新激活菜单
          this.activeMenu = item.path;
          this.$router.push({ path: item.path });
        }
      }
    },

    // 处理菜单选中事件
    handleMenuSelect(selectedKeys, selectedItems) {
      console.log(selectedKeys, selectedItems);
    },

    // 处理搜索
    handleSearch() {
      // 如果关键字为空，重置搜索状态
      if (!this.searchKeyword.trim()) {
        this.clearSearch();
      }
    },

    // 清除搜索
    clearSearch() {
      this.searchKeyword = "";
    },

    // 判断子菜单是否激活
    isSubMenuActive(item) {
      // 缓存计算结果，减少重复计算
      if (!item.children || item.children.length === 0) {
        return this.activeMenu === item.path;
      }

      // 检查当前路径是否以父菜单路径开头或者有子菜单被激活
      return (
        this.activeMenu.startsWith(item.path) ||
        item.children.some((child) => this.activeMenu === child.path)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  width: 100%;

  .el-aside {
    display: flex;
    flex-direction: column;

    .logo-container {
      flex-shrink: 0; /* 防止logo被压缩 */
    }

    .search-box {
      flex-shrink: 0; /* 防止搜索框被压缩 */
    }
  }

  /* 添加菜单图标样式 */
  .menu-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
    display: inline-block;
  }

  /* 确保选中菜单项内的图标显示正确 */
  .el-menu-item.is-active .menu-icon,
  .el-submenu.is-active > .el-submenu__title .menu-icon {
    filter: brightness(1.2);
  }

  /* 折叠菜单时的图标样式 */
  .el-menu--collapse .menu-icon {
    margin-right: 0;
  }

  .logo-container {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    margin-top: 5px;
    // border-bottom: 1px solid #f0f0f0;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    .logo {
      height: 45px;
      width: 50px;
      transition: all 0.3s ease-in-out;
      position: relative;
      z-index: 2;
    }
    .logo-text {
      margin-left: 10px;
      white-space: nowrap;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      z-index: 1;
    }
  }

  .search-box {
    padding: 0 16px;
    margin-bottom: 16px;

    .search-text {
      font-size: 12px;
      color: #999;
      margin-bottom: 4px;
    }

    .el-input {
      border-radius: 4px;

      ::v-deep .el-input__inner {
        border-radius: 4px;
        background-color: #f5f7fa;
        border: none;
        height: 36px;

        &:focus {
          background-color: #fff;
          border: 1px solid #dcdfe6;
        }
      }
    }

    .no-results {
      padding: 10px;
      text-align: center;
      color: #999;
      font-size: 12px;
      margin-top: 5px;
      background-color: #f5f7fa;
      border-radius: 4px;
    }
  }

  .sidebar-menu {
    border-right: none;
    max-height: none; /* 让菜单自动扩展占满空间 */
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    flex: 1;
    scroll-behavior: smooth;
    will-change: width, transform;
    transform: translateZ(0);

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }

    /* 子菜单样式 */
    .el-submenu {
      &.is-active {
        .el-submenu__title {
          color: #4bb5fb;
        }
      }

      .el-submenu__title {
        height: 50px;
        line-height: 50px;
        margin: 4px 0;
        padding: 0 16px !important;
        border-radius: 0;
        font-size: 14px;

        &:hover {
          background-color: rgba(75, 181, 251, 0.08);
          color: #4bb5fb;
        }
      }

      .el-menu {
        background-color: #f8f9fc;
        padding: 5px 0;

        .el-menu-item {
          height: 50px;
          line-height: 50px;
          margin: 2px 0;
          padding-left: 48px !important;
          font-size: 13px;

          &.is-active {
            background-color: #3366ff !important;
            color: #fff !important;
            font-weight: 500;
            border-radius: 4px;
            margin-left: 10px;
            margin-right: 10px;
            padding-left: 40px !important;
            width: calc(100% - 20px);
          }

          &:hover:not(.is-active) {
            background-color: rgba(75, 181, 251, 0.08);
            color: #4bb5fb;
          }
        }
      }
    }

    .el-menu-item {
      height: 50px;
      line-height: 50px;
      margin: 4px 0;
      padding: 0 16px !important;
      border-radius: 0;
      font-size: 14px;
      transform-origin: left center;
      transition: all 0.3s ease-in-out, transform 0.3s ease-in-out,
        background-color 0.3s ease-in-out !important;

      &.is-active {
        background-color: #3366ff !important;
        color: #fff !important;
        font-weight: 500;
        border-radius: 4px;
        margin-left: 10px;
        margin-right: 10px;
        width: calc(100% - 20px);
      }

      &:hover:not(.is-active) {
        background-color: rgba(75, 181, 251, 0.08);
        color: #4bb5fb;
      }
    }
  }

  .el-menu--collapse {
    width: 64px;
    transition: width 0.3s ease-in-out, padding 0.3s ease-in-out !important;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }

    .el-menu-item,
    .el-submenu__title {
      padding: 0 !important;
      text-align: center;

      &.is-active {
        margin-left: 5px;
        margin-right: 5px;
        width: calc(100% - 10px);
      }
    }
  }

  /* 折叠菜单弹出的子菜单样式 */
  .el-menu--vertical {
    .el-menu-item {
      height: 40px;
      line-height: 40px;

      &.is-active {
        color: #fff !important;
        background-color: #3366ff !important;
        border-radius: 4px;
        margin: 0 5px;
        width: calc(100% - 10px);
      }

      &:hover:not(.is-active) {
        background-color: rgba(75, 181, 251, 0.08);
        color: #4bb5fb;
      }
    }

    .el-submenu__title {
      height: 50px;
      line-height: 50px;
    }
  }

  .top-header {
    padding-top: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 0;
    right: 0;
    height: 9%;
    width: 100%;

    .nav-title {
      position: absolute;
      left: 50px;
      width: 240px;
      font-weight: bold;
      font-size: 20px;
      line-height: 50px;
    }

    .user-flex {
      align-items: center;
      display: flex;
      justify-content: flex-end;
      font-size: 13px;
      line-height: 1.5;
      color: #56597e;
      height: 50px;
      overflow-wrap: break-word;
      font-family: -apple-system, blinkmacsystemfont, "Segoe UI", "PingFang SC",
        "Hiragino Sans GB", "Microsoft YaHei", helvetica neue, helvetica, arial,
        sans-serif;
      min-width: 120px;

      .user-action-item {
        display: flex;
        align-items: center;
        // margin-left: 16px;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;
        position: relative; // 添加相对定位，用于下拉框定位

        &:hover {
          background-color: #f5f7fa;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }

      .user-vip {
        background-color: #fffaf1;
        font-weight: bold;
        font-size: 12px;
      }

      // 消息下拉框样式
      .user-message {
        .message-dropdown {
          position: absolute;
          top: calc(100% + 5px);
          right: 0;
          width: 320px;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          z-index: 1000;
          padding: 12px;
          max-height: 400px;
          overflow-y: auto;

          &:before {
            content: "";
            position: absolute;
            top: -6px;
            right: 16px;
            width: 12px;
            height: 12px;
            background-color: #fff;
            transform: rotate(45deg);
            border-left: 1px solid #ebeef5;
            border-top: 1px solid #ebeef5;
          }

          .message-list {
            .message-item {
              padding: 10px;
              border-bottom: 1px solid #f0f0f0;
              cursor: pointer;
              transition: all 0.2s;

              &:hover {
                background-color: #f5f7fa;
              }

              &:last-child {
                border-bottom: none;
              }

              .message-title {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 4px;
                color: #303133;
              }

              .message-content {
                font-size: 13px;
                color: #606266;
                margin-bottom: 4px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .message-time {
                font-size: 12px;
                color: #909399;
                text-align: right;
              }
            }
          }

          .message-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 30px 0;
            color: #909399;

            p {
              font-size: 14px;
              margin: 0;
            }
          }
        }
      }

      .user-name {
        cursor: pointer;
      }
    }
  }
  .main-content {
    position: absolute;
    top: 9%;
    right: 0;
    height: 90%;
    overflow-y: auto;
    width: 100%;
  }
  .collapse-menu-btn {
    position: absolute;
    left: v-bind('isMenuCollapsed ? "64px" : "200px"');
    top: 30px;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-left: none;
    border-radius: 0 4px 4px 0;
    transition: all 0.3s ease-in-out;
    z-index: 1000;
    margin-left: 5px;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);

    &:hover {
      background-color: #f5f7fa;
      color: #2468f2;
    }

    &.collapsed {
      left: 64px;
    }
  }
}

.el-menu {
  border-right: none;
}

/* 菜单项过渡动画 */
.el-menu-item {
  transition: all 0.3s ease-in-out;
}

/* 侧边栏内容过渡动画 */
.search-box {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.sidebar-menu {
  transition: width 0.3s ease-in-out;
}

/* 添加进入和离开的动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 水平方向的淡入淡出效果 */
.fade-horizontal-enter-active,
.fade-horizontal-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  transform-origin: left center;
}

.fade-horizontal-enter,
.fade-horizontal-leave-to {
  opacity: 0;
  transform: translateX(-15px);
}

/* 弹出菜单中的图标样式 */
.el-menu--popup {
  .menu-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
  }
}

/* 防止菜单项在滚动时被截断 */
.el-submenu .el-menu {
  overflow: visible !important;
}

/* 确保菜单滚动时不会影响其他元素 */
.sidebar-menu {
  overflow-x: hidden;
}
</style>
<style>
.el-loading-spinner {
  margin: 0 !important;
}

/* 覆盖Element UI默认的菜单项激活样式 */
.el-menu-item.is-active {
  background-color: #3366ff !important;
  color: #fff !important;
}

.el-submenu.is-active .el-submenu__title {
  color: #3366ff !important;
}

.el-menu--popup .el-menu-item.is-active {
  background-color: #3366ff !important;
  color: #fff !important;
}

/* 处理弹出菜单 */
.el-menu--horizontal .el-menu-item.is-active,
.el-menu--horizontal .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #3366ff !important;
}

/* 强制覆盖内联样式 */
.el-menu .is-active {
  background-color: #3366ff !important;
}

/* 处理各种特殊情况 */
.el-menu-item.is-active:hover,
.el-menu-item.is-active:focus {
  background-color: #3366ff !important;
  color: #fff !important;
}

/* 处理鼠标悬停在已激活项上时的颜色 */
.el-menu-item.is-active:hover {
  background-color: #3366ff !important;
}

/* 在scoped样式中，为.sidebar-menu添加特殊样式 */
.sidebar-menu .el-menu-item.is-active {
  background-color: #3366ff !important;
  color: #fff !important;
}

/* 为折叠菜单添加特殊样式 */
.el-menu--collapse .el-menu-item.is-active {
  background-color: #3366ff !important;
}

/* 为折叠菜单的弹出菜单添加特殊样式 */
.el-menu--popup-container .el-menu-item.is-active {
  background-color: #3366ff !important;
}
</style>
